import Icon from '../components/Icon.vue'

Icon.register({
  'people-carry': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM512 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM637.7 468.1c6.6 16.4-1.4 35-17.8 41.6-3.9 1.6-7.9 2.3-11.9 2.3-12.7 0-24.7-7.6-29.7-20.1l-27.7-69.2 2-18.2 41.1-46.4zM603.5 258.3c4.6 20-0.8 41.2-14.4 56.7l-67.2 75.9-10.1 92.6c-1.8 16.4-15.7 28.5-31.8 28.5-1.2 0-2.3-0.1-3.5-0.2-17.5-1.9-30.2-17.7-28.3-35.3l10.1-92.8c1.5-13 6.9-25.1 15.6-35l43.3-49-17.6-70.3-6.8 20.4c-4.1 12.6-11.9 23.4-24.5 32.6l-51.1 32.5c-4.6 2.9-12.1 4.6-17.2 5h-160c-5.1-0.4-12.6-2.1-17.2-5l-51.1-32.5c-12.6-9.2-20.4-20.1-24.5-32.6l-6.8-20.4-17.6 70.3 43.3 49c8.7 9.9 14.1 22 15.6 35l10.1 92.8c1.9 17.6-10.7 33.4-28.3 35.3-1.2 0.1-2.3 0.2-3.5 0.2-16.2 0-30-12.2-31.8-28.5l-10.1-92.6-67.2-75.9c-13.7-15.5-19-36.7-14.4-56.7l18.4-80.2c4.6-20 18.6-36.8 37.5-44.9 18.5-8 38.9-6.7 56.1 3.3 22.7 13.4 39.8 34.4 48.1 59.4l11.3 33.9 16.1 10.2v-96c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v96l16-10.2 11.3-33.9c8.4-24.9 25.4-46 48.1-59.4 17.1-10 37.6-11.3 56.1-3.3 18.9 8.1 32.9 24.9 37.5 44.9zM46.3 358.1l41.1 46.4 2 18.2-27.7 69.2c-6.5 16.1-24.8 24.4-41.6 17.8-16.4-6.6-24.4-25.2-17.8-41.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/people-carry.js
// module id = null
// module chunks = 